import React, {
  useCallback,
  useEffect,
  useMemo,
  useState,
  Fragment,
} from 'react';
import { useMediaQuery } from 'react-responsive';
import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import Title from 'components/Granel/TechnicalDocumentation/Title';

import { getTechnicalDocumentsOs } from 'services/technicalDocumentationServices';
import FileItemOs from 'components/Granel/TechnicalDocumentation/FileItemOs';
import { useDocumentationOS } from 'hooks/useDocumentationOS';
import FakeItems from 'components/Granel/TechnicalDocumentation/FakeItems';
import { useTour } from 'hooks/useTour';
import { TableWrap } from 'pages/BankSlip/styles';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import { Scrollbar, BoxPadding, Container, ItemsWrap } from './styles';
import { EmptyItems } from '../documentacao/styles';

function TechnicalDocumentationOs() {
  const [siteCode, setSiteCode] = useState(null);
  const [itemsResponse, setItensResponse] = useState([]);
  const [items, setItems] = useState([]);
  const [loader, setLoader] = useState(false);

  const isMobile = useMediaQuery({ maxWidth: 620 });

  const { getNewItens, setGetNewItens } = useDocumentationOS();
  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('documentacao-os');
    setSteps(1);
  }, [showTour, setTourType, setSteps]);

  useEffect(() => {
    async function getSiteCode() {
      const customerSiteCode = await localStorage.getItem(
        '@UltragazEmpresarial:customerSiteCode'
      );
      setSiteCode(customerSiteCode);
    }
    if (!siteCode) getSiteCode();
  }, [siteCode]);

  const getItems = useCallback(async () => {
    setLoader(true);
    const response = await getTechnicalDocumentsOs(siteCode);
    if (response?.length) {
      setItensResponse(response);
    }
    setLoader(false);
  }, [siteCode]);

  useEffect(() => {
    if (siteCode) getItems();
  }, [siteCode]);

  useEffect(() => {
    if (getNewItens) {
      getItems();
      setGetNewItens(false);
    }
  }, [getNewItens, setGetNewItens]);

  const itemsTransform = useMemo(() => {
    return itemsResponse.map((item, idx) => ({
      ...item,
      isCheckedItem: false,
      itemId: idx,
    }));
  }, [itemsResponse]);

  useEffect(() => {
    if (itemsTransform?.length) {
      setItems(itemsTransform);
    }
  }, [itemsTransform]);

  return (
    <Navbar selected="documentacao-os" openSubMenu="main-manutencao">
      <UserMenu
        className="pb-2"
        breadcrump="› Histórico de ordens de serviço"
        intro={() => true}
      />
      <BoxPadding>
        <Scrollbar>
          <Container>
            <Title
              title="Histórico de ordens de serviços"
              subTitle="Documentos referente à manutenção da central de gás."
              legends={[
                {
                  acronym: 'ME',
                  description: 'Manutenção emergencial',
                },
                {
                  acronym: 'MC',
                  description: 'Manutenção corretiva',
                },
                {
                  acronym: 'MP',
                  description: 'Manutenção preventiva',
                },
                {
                  acronym: 'NR13',
                  description: 'Inspeção periódica',
                },
              ]}
            />
            <TableWrap
              showTour={
                showTour && tourType === 'documentacao-os' && tourStep === 1
              }
            >
              <ItemsWrap>
                {!loader && items.length === 0 && (
                  <EmptyItems>Nenhum documento encontrado!!</EmptyItems>
                )}
                {!loader &&
                  items.length > 0 &&
                  items.map((item) => (
                    <Fragment key={item.numberOs}>
                      <FileItemOs
                        osNumber={item.numberOs}
                        createdDate={item.datecreatedOs}
                        installedBaseNickname={item.installedBase}
                        installedBaseCode={item.installedBaseCode}
                        osType={item.typeOs}
                        link={item.link}
                      />
                    </Fragment>
                  ))}
                {loader && <FakeItems isMobile={isMobile} />}
              </ItemsWrap>
              {showTour && tourType === 'documentacao-os' && tourStep === 1 && (
                <TourBalloon
                  title="Lista com as Ordens de Serviço"
                  content="Aqui são exibidos todos as Ordens de Serviço. Você pode baixá-las ou enviá-las por e-mail."
                  position={{
                    left: '50%',
                    right: '0',
                    top: '-192px',
                    arrowPosition: 'bottom',
                    maxWidth: 'unset',
                    boxShadow: false,
                    width: '492px',
                    transform: 'translateX(-50%)',
                  }}
                />
              )}
            </TableWrap>
          </Container>
        </Scrollbar>
      </BoxPadding>
    </Navbar>
  );
}

export default TechnicalDocumentationOs;
